import { isNil, omitBy, some, startsWith } from 'lodash';
import { push } from 'react-router-redux';
import url from 'url';

import { getSearchParameters } from '../state';
import { BasePaths, SearchParameterToQuery } from '../constants';

// these are "internal use" query params that are sent to search-service but
// are not meant to be deeplinkable as query parameters
export const IGNORED_PARAMS = Object.freeze([
    'directoryId',
    'excludeSpecialties',
    'geoShape',
    'mockSearchGql',
    'pickerErrorOverride',
    'practiceId',
]);

// get everything up to the first dynamic param
const searchPathPrefixes = BasePaths.map(path => path.split(':')[0]);

export const formQueryObject = searchParams => {
    return Object.keys(searchParams).reduce((queryMap, param) => {
        if (!IGNORED_PARAMS.includes(param)) {
            queryMap[SearchParameterToQuery[param]] = searchParams[param];
        }

        return queryMap;
    }, {});
};

export const stringifyFacetedSearchFilters = searchParams => {
    const { filters } = searchParams;

    if (filters) {
        return JSON.stringify(filters);
    } else {
        return null;
    }
};

const updateQueryParameters = (currentUrl = window.location.href) =>
    async (dispatch, getState) => {
        const { pathname } = url.parse(currentUrl);
        let shouldRedirect = false;

        // if using the search bar from a non-search page, updating the URL
        // should also redirect us to search
        if (!some(searchPathPrefixes, path => startsWith(pathname, path))) {
            shouldRedirect = true;
        }

        const state = getState();
        const searchParams = getSearchParameters(state);
        const query = omitBy({
            ...formQueryObject(searchParams),
            filters: stringifyFacetedSearchFilters(searchParams),
        }, isNil);

        if (shouldRedirect) {
            window.location.assign(
                url.format({
                    pathname: '/search',
                    query,
                })
            );
        } else {
            return dispatch(push({
                pathname,
                query,
            }));
        }
    };

export default updateQueryParameters;
